import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    selector: String,
    resetSelector: String,
    className: String,
  }

  connect() {
    this.apply();
  }

  apply() {
    $(this.resetSelectorValue, this.element).removeClass(this.classNameValue);
    $(this.selectorValue, this.element).addClass(this.classNameValue);
  }
}
